import React, { Component } from 'react';
import { isEmpty } from "lodash"
import { Box, Button, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow } from '@mui/material';
import { CloudDownloadRounded } from '@mui/icons-material';
import { orderByDateAsc, orderByDateDsc, orderByDsc } from '../../../store/actions/format';
import Currency from '../../common/Currency';

// Champ CSV : guillemets doublés, champ entouré de guillemets s'il contient , " ou saut de ligne
const csvField = (value) => {
    if (value === undefined || value === null) return ''
    if (typeof value === 'number') return Number.isFinite(value) ? String(value) : ''
    const str = String(value)
    return /[,"\r\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str
}

const csvDate = (value) => {
    if (!value) return ''
    const date = new Date(value)
    return isNaN(date.getTime()) ? '' : date.toLocaleDateString('fr-FR')
}

class SupplierBalance extends Component {
    state = { 

    }
    formatlist = () => {
        const { PAYMENT_DETAILS, ADVANCES, SPENDINGS, supplier } = this.props;
        let total = 0
        let tmpList = []
        let lists = {}

        let payments = Object.values(PAYMENT_DETAILS).filter(pay => {
            if (pay.payment_spending_id && SPENDINGS[pay.payment_spending_id] && pay.payment_details_mode !== "ACOMPTE") {

                return SPENDINGS[pay.payment_spending_id].spending_supplier === supplier.supplier_id
            }
        })

        let advances = !isEmpty(ADVANCES) ? Object.values(ADVANCES).filter(item => item.advance_supplier_id === supplier.supplier_id) : []
        let spendings = !isEmpty(SPENDINGS) ? Object.values(SPENDINGS).filter(item => item.spending_supplier === supplier.supplier_id) : []

        payments.forEach(pay => {
            let tmp = {
                id: `payment:${pay.payment_details_id}`,
                debit: pay.payment_amount,
                date: pay.payment_details_date,
                desc: pay.payment_details_ref,
                mode: pay.payment_details_mode,
            }
            tmpList.push(tmp)
            total -= pay.payment_amount
        })

        advances.forEach(pay => {
            let tmp = {
                id: `advance:${pay.advance_id}`,
                debit: pay.advance_amount,
                date: pay.advance_date,
                desc: pay.advance_ref,
                mode: pay.advance_payment_mode,
            }
            tmpList.push(tmp)
            total -= pay.advance_amount
        })
        spendings.forEach(pay => {
            let tmp = {
                id: `spending:${pay.spending_id}`,
                credit: pay.spending_amountTTC,
                date: pay.spending_date,
                desc: pay.spending_desc,
                mode: pay.spending_payment_mode,
            }
            tmpList.push(tmp)
            total += pay.spending_amountTTC
        })
        tmpList = orderByDateAsc(tmpList)
        tmpList.forEach(item => lists[item.id] = item)

        return [Object.values(lists), total]
    }

    handleExportCSV = () => {
        const { supplier } = this.props;
        const [rows, total] = this.formatlist()
        const lines = [['Créé le', 'Description', 'Débit', 'Crédit']]
        // même ligne « Solde » que le tableau affiché
        lines.push(['Solde', '', total > 0 ? total : '', total <= 0 ? total * -1 : ''])
        rows.forEach(item => lines.push([csvDate(item.date), item.desc, item.debit, item.credit]))

        const csv = lines.map(line => line.map(csvField).join(',')).join('\n') + '\n'
        const label = String(supplier.supplier_category || supplier.supplier_name || supplier.supplier_id || 'fournisseur')
            .replace(/[^A-Za-z0-9_-]+/g, '_').replace(/^_+|_+$/g, '') || 'fournisseur'
        const day = new Date().toISOString().slice(0, 10)

        const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8;' }))
        const link = document.createElement('a')
        link.href = url
        link.download = `balance_${label}_${day}.csv`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
    }

    displayList = () => {
        let list = this.formatlist()
       
        return [list[0].map( item => (
            <TableRow 
                hover
                key={item.id}
            >
                <TableCell >{new Date(item.date).toLocaleDateString('fr-FR')}</TableCell>
                <TableCell >{item.desc}</TableCell>                     
                <TableCell><Currency value={item.debit} /></TableCell>                     
                <TableCell><Currency value={item.credit} /></TableCell>                         
            </TableRow>
        )), list[1]]
    }
    render() {
        const { PAYMENTS, ADVANCES, SPENDINGS } = this.props;
        let data = this.displayList()
        return (
            <Box>
                <Box display="flex" justifyContent="flex-end">
                    <Button color="primary" startIcon={<CloudDownloadRounded />} onClick={this.handleExportCSV}>
                        Exporter CSV
                    </Button>
                </Box>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Créé le</TableCell>
                            <TableCell>Description</TableCell>
                            {/* <TableCell>Mode</TableCell> */}
                            <TableCell>Débit</TableCell>
                            <TableCell>Crédit</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow 
                            hover
                            key="solde"
                        >
                            <TableCell style={{ fontStyle: 'italic', fontSize: '18px',fontWeight: 'bold'}} colSpan={2}>Solde</TableCell>   
                            <TableCell style={{ fontStyle: 'italic', fontSize: '18px',fontWeight: 'bold'}}>{data[1] > 0 && <Currency value={data[1] } />}</TableCell>                     
                            <TableCell style={{ fontStyle: 'italic', fontSize: '18px',fontWeight: 'bold'}}>{data[1] <= 0 && <Currency value={data[1]*-1} />}</TableCell>                         
                        </TableRow>
                        {data[0]}
                    </TableBody>
                    {/* {size(spendings) > 10 &&
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[10, 30]}
                                    colSpan={5}
                                    count={size(spendings)}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    SelectProps={{
                                        native: true,
                                    }}
                                    onPageChange={this.handleChangePage}
                                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                                    ActionsComponent={Pagination}
                                />
                            </TableRow>
                        </TableFooter>
                    } */}
                </Table>
            </Box>
        );
    }
}

export default SupplierBalance;